const DEFAULT_SIGN_IN_ERROR_MESSAGE = 'Invalid login credentials. Please try again.';

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

const getFirstFieldValidationMessage = (data: Record<string, unknown>): string | undefined => {
  for (const value of Object.values(data)) {
    if (Array.isArray(value)) {
      const message = value.find(isNonEmptyString);
      if (message) {
        return message;
      }
    }

    if (isNonEmptyString(value)) {
      return value;
    }
  }

  return undefined;
};

export const getSignInErrorMessage = (
  error: { data?: unknown } | undefined,
  fallback = DEFAULT_SIGN_IN_ERROR_MESSAGE,
): string => {
  const data = error?.data;

  if (!data) {
    return fallback;
  }

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  if (typeof data === 'object' && data !== null) {
    const errorData = data as Record<string, unknown>;

    if (isNonEmptyString(errorData.message)) {
      return errorData.message;
    }

    if (getFirstFieldValidationMessage(errorData)) {
      return fallback;
    }

    if (isNonEmptyString(errorData.error)) {
      return errorData.error;
    }
  }

  return fallback;
};
